import styled from 'styled-components';
import device from 'utils/device';

export const Avatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid ${window?.settings?.primary_color ?? '#1DBD6B'};

  @media ${device.tablet} {
    width: 48px;
    height: 48px;
  }
`;
